import { useMemo } from 'react';

/**
 * 클로브 금융 판매 허용 목록
 * 'all' 일 경우 모든 회사에서 판매 가능
 * 특정 회사 ID 일 경우 해당 회사에서만 판매 가능
 */
const ALLOW_LIST = ['all'];

export const useTradeAllowed = (companyId: string) => {
  const isTradeAllowed = useMemo(() => {
    if (ALLOW_LIST.includes('all')) {
      return true;
    }
    return ALLOW_LIST.includes(companyId);
  }, [companyId]);

  return isTradeAllowed;
};
